import React, { useCallback, useEffect, useMemo, useState } from 'react'
import { TextField } from '@mui/material'
import _ from 'lodash'

interface TextFieldsProps {
    label: string
    type?: React.HTMLInputTypeAttribute
    value: string
    onValueChange: (val: string) => void
    disabled?: boolean
    required?: boolean
    error?: boolean
    helperText?: string
    placeholder?: string
    debounceOff?: boolean
    multiline?: boolean
    maxRows?: number

}
const CustomTextField = React.memo(function FieldInput({ label, value, placeholder, onValueChange, disabled, required, debounceOff, error, helperText, type, multiline, maxRows }: TextFieldsProps) {
    const [localValue, setLocalValue] = useState(value)

    useEffect(() => {
        setLocalValue(value)
    }, [value])

    const debouncedUpdate = useMemo(
        () => _.debounce((val: string) => onValueChange(val), 200),
        [onValueChange]
    )

    useEffect(() => {
        return () => {
            debouncedUpdate.cancel()
        }
    }, [debouncedUpdate])

    const handleChange = useCallback(
        (e: React.ChangeEvent<HTMLInputElement>) => {
            const val = e.target.value
            setLocalValue(val)
            if (debounceOff) {
                onValueChange(val)
            } else {
                debouncedUpdate(val)
            }
        },
        [debouncedUpdate, onValueChange, debounceOff]
    )

    return (
        <TextField
            type={type}
            label={label}
            value={localValue}
            required={required}
            disabled={disabled}
            error={error}
            helperText={helperText}
            placeholder={placeholder}
            onChange={handleChange}
            multiline={multiline}
            maxRows={maxRows}
            fullWidth
            size='small'
        />
    )
})

export default CustomTextField
